import { ALL_BU, ALL_STORE } from "constants/DashboardContanst";
import { AUTH_STATUS_NEW } from "constants/FormatDataContanst";
import {
  INVOICE_POS_BUYER_FIELD,
  LINK_TYPE,
  MODE_INVOICE_POS_ACTION,
  TYPE_ACTION_WORKFLOW,
  TYPE_INVOICE_POS_ANOTHER,
} from "constants/InvoicePosConstant";
import { base64toBlob, errorMessage } from "helpers/utils";
import moment from "moment";
import { FIELD_CUSTOMER } from "pages/GeneralInfo/Customer/utils";
import { TYPE_AUTO_RELOAD } from "pages/InvoicePos/utils";
import { call, put, select, takeEvery } from "redux-saga/effects";
import CustomerService from "services/CustomerService";
import InvoicePosService from "services/InvoicePosService";
import {
  createInvoicePosFail,
  createInvoicePosSuccess,
  downloadXmlInvoicePosFail,
  downloadXmlInvoicePosSuccess,
  editInvoicePosFail,
  editInvoicePosSuccess,
  generateNumberInvoicePosFail,
  generateNumberInvoicePosSuccess,
  getDetailInvoicePosFail,
  getDetailInvoicePosSuccess,
  getEnterpriseByTaxCodeFail,
  getEnterpriseByTaxCodeSuccess,
  listInvoicePosFail,
  listInvoicePosSuccess,
  loadConfigInvoicePosFieldFail,
  loadConfigInvoicePosFieldSuccess,
  releaseInvoicePosFail,
  releaseInvoicePosSuccess,
  transferUsbInvoicePosFail,
  transferUsbInvoicePosSuccess,
} from "store/actions";
import {
  ACTION_WORKFLOW_INVOICE_POS,
  ADJUST_INVOICE_POS,
  ATTACK_FILE_INVOICE_POS_UPLOAD,
  CALL_BACK_TAX_REFUSED_APPROVAL_INVOICE_POS,
  CANCEL_INVOICE_POS,
  CLONE_ENVOICE_POS,
  CREATE_INVOICE_POS_ENTERPRISE,
  CREATE_INVOICE_POS_ENTERPRISE_ADJUST_ALL,
  DELETE_INVOICE_POS,
  DOWNLOAD_XML_INVOICE_POS,
  DOWNLOAD_ZIP_INVOICE_POS,
  EXPORT_INVOICE_POS,
  EXPORT_INVOICE_POS_TICKET,
  EXPORT_INVOICE_POS_WAREHOUSES,
  EXPORT_INVOICE_POS_WAREHOUSES_AGENCY,
  GENERATE_NUMBER_INVOICE_POS,
  GET_CURRENT_TIME_POS,
  GET_DATA_LINK_POS,
  GET_ENTERPRISE_POS_BY_TAX_CODE,
  GET_INVOICE_POS_MAX_DATE,
  GET_INVOICE_POS_MIN_DATE,
  GET_INVOICE_POS_REPORT_WORD,
  INVOICE_POS_CAMPAIGN_DETAIL,
  INVOICE_POS_CAMPAIGN_LIST,
  INVOICE_POS_CREATE,
  INVOICE_POS_DETAIL,
  INVOICE_POS_EDIT,
  INVOICE_POS_LIST,
  LOAD_CONFIG_INVOICE_POS_FIELD,
  PHASE_INVOICE_POS_DETAIL,
  PHASE_INVOICE_POS_LIST,
  PREVIEW_PDF_INVOICE_POS,
  RELEASE_CAMPAIGNS_INVOICE_POS,
  RELEASE_INVOICE_POS,
  REMOVE_FILE_INVOICE_POS,
  REPLACE_INVOICE_POS,
  SEND_MAIL_INVOICE_POS,
  TRANSFER_USB_INVOICE_POS,
  UPLOAD_CAMPAIGNS_INVOICE_POS,
  UPLOAD_FILE_INVOICE_POS,
} from "./actionTypes";
import {
  actionWorkflowInvoicePosFail,
  actionWorkflowInvoicePosSuccess,
  adjustInvoicePosFail,
  adjustInvoicePosSuccess,
  backupDataNewPos,
  callBackTaxRefusedApprovalInvoicePosFail,
  callBackTaxRefusedApprovalInvoicePosSuccess,
  cancelInvoicePosFail,
  cancelInvoicePosSuccess,
  createInvoicePosEnterpriseAdjustAllFail,
  createInvoicePosEnterpriseAdjustAllSuccess,
  createInvoicePosEnterpriseFail,
  createInvoicePosEnterpriseSuccess,
  deleteInvoicePosFail,
  deleteInvoicePosSuccess,
  downloadZipInvoicePosFail,
  downloadZipInvoicePosSuccess,
  exportInvoicePosFail,
  exportInvoicePosSuccess,
  exportInvoicePosTicketFail,
  exportInvoicePosTicketSuccess,
  exportInvoicePosWarehousesAgencyFail,
  exportInvoicePosWarehousesAgencySuccess,
  exportInvoicePosWarehousesFail,
  exportInvoicePosWarehousesSuccess,
  getCloneEnvoicePosFail,
  getCloneEnvoicePosSuccess,
  getCurrentTimePosFail,
  getCurrentTimePosSuccess,
  getDataLinkPosFail,
  getDataLinkPosSuccess,
  getDetailPhaseInvoicePosFail,
  getDetailPhaseInvoicePosSuccess,
  getInvoicePosCampaignListFail,
  getInvoicePosCampaignListSuccess,
  getInvoicePosMaxDateFail,
  getInvoicePosMaxDateSuccess,
  getInvoicePosMinDateFail,
  getInvoicePosMinDateSuccess,
  getInvoicePosReportWordFail,
  getInvoicePosReportWordSuccess,
  invoicePosCampaignDetailFail,
  invoicePosCampaignDetailSuccess,
  listPhaseInvoicePosFail,
  listPhaseInvoicePosSuccess,
  previewPdfInvoicePosFail,
  previewPdfInvoicePosSuccess,
  releaseCampaignsInvoicePosFail,
  releaseCampaignsInvoicePosSuccess,
  removeFileInvoicePosFail,
  removeFileInvoicePosSuccess,
  replaceInvoicePosFail,
  replaceInvoicePosSuccess,
  sendMailInvoicePosFail,
  sendMailInvoicePosSuccess,
  uploadAttackFileInvoicePosFail,
  uploadAttackFileInvoicePosSuccess,
  uploadCampaignsInvoicePosFail,
  uploadCampaignsInvoicePosSuccess,
  uploadFileInvoicePosFail,
  uploadFileInvoicePosSuccess,
} from "./actions";

function* getCloneEnvoicePos({
  id,
  typeInvoicePosAnother,
  approveStatus = undefined,
}) {
  try {
    let response = null;
    if (typeInvoicePosAnother === TYPE_INVOICE_POS_ANOTHER.DELIVERY_BILL) {
      response = yield call(
        InvoicePosService.cloneInvoicePosWarehouses,
        id,
        approveStatus
      );
    } else if (
      typeInvoicePosAnother === TYPE_INVOICE_POS_ANOTHER.WAREHOUSE_AGENCY
    ) {
      response = yield call(
        InvoicePosService.cloneWarehousesAgency,
        id,
        approveStatus
      );
    } else {
      response = yield call(InvoicePosService.cloneEnvoice, id, approveStatus);
    }
    yield put(getCloneEnvoicePosSuccess(response));
  } catch (error) {
    yield put(getCloneEnvoicePosFail(errorMessage(error)));
  }
}

function* sendMailInvoicePos({ id, listEmail, isInvoicePosError }) {
  try {
    let response = null;
    if (isInvoicePosError) {
      response = yield call(
        InvoicePosService.sendMailInvoicePosError,
        id,
        listEmail
      );
    } else {
      response = yield call(
        InvoicePosService.sendMailInvoicePos,
        id,
        listEmail
      );
    }
    if (response.result) {
      yield put(
        backupDataNewPos({
          id,
          typeAutoReload: TYPE_AUTO_RELOAD.IS_SEND_MAIL,
        })
      );
      yield put(sendMailInvoicePosSuccess());
    } else {
      yield put(sendMailInvoicePosFail("Gửi mail thất bại"));
    }
  } catch (error) {
    yield put(sendMailInvoicePosFail(errorMessage(error)));
  }
}

function* fetchListInvoicePos({ payload, typeInvoicePosAnother }) {
  try {
    let response = null;
    let { finalListBuCode, listBuOfTenant, buStoreHeader, buTenantHeaderInfo } =
      yield select(state => state.Dashboard);
    let bu_parent = undefined;
    let bu_code = undefined;
    if (buStoreHeader === ALL_STORE) {
      bu_parent = buTenantHeaderInfo.id;
    } else if (buStoreHeader === ALL_BU) {
      bu_parent = listBuOfTenant
        .filter(item => item.id)
        .map(item => item.id)
        .join(",");
    } else {
      bu_code = buStoreHeader;
    }
    if (typeInvoicePosAnother === TYPE_INVOICE_POS_ANOTHER.INVOICE_TICKETS) {
      response = yield call(
        InvoicePosService.listInvoicePosTickets,
        payload,
        bu_code,
        bu_parent
      );
    } else if (
      typeInvoicePosAnother === TYPE_INVOICE_POS_ANOTHER.DELIVERY_BILL
    ) {
      response = yield call(
        InvoicePosService.listDeliveryBill,
        payload,
        bu_code,
        bu_parent
      );
    } else if (
      typeInvoicePosAnother === TYPE_INVOICE_POS_ANOTHER.WAREHOUSE_AGENCY
    ) {
      response = yield call(
        InvoicePosService.listWarehouseAgency,
        payload,
        bu_code,
        bu_parent
      );
    } else if (
      typeInvoicePosAnother === TYPE_INVOICE_POS_ANOTHER.INVOICE_TOTAL
    ) {
      response = yield call(
        InvoicePosService.listPendingBills,
        payload,
        bu_code,
        bu_parent
      );
      let i = 0;
      response.items = response.items.map(item => {
        i++;
        return {
          index: i,
          ...item,
        };
      });
    } else if (typeInvoicePosAnother === TYPE_INVOICE_POS_ANOTHER.ERROR_TCT) {
      response = yield call(
        InvoicePosService.listInvoicePosTCTError,
        payload,
        bu_code,
        bu_parent
      );
    } else if (
      typeInvoicePosAnother === TYPE_INVOICE_POS_ANOTHER.ERROR_DELIVERY_BILL_TCT
    ) {
      response = yield call(
        InvoicePosService.listDeliveryBillTCTError,
        payload,
        bu_code,
        bu_parent
      );
    } else if (
      typeInvoicePosAnother ===
      TYPE_INVOICE_POS_ANOTHER.ERROR_WAREHOUSE_AGENCY_TCT
    ) {
      response = yield call(
        InvoicePosService.listWareHouseAgencyTCTError,
        payload,
        bu_code,
        bu_parent
      );
    } else if (
      typeInvoicePosAnother === TYPE_INVOICE_POS_ANOTHER.INVOICE_BATCH_DETAILS
    ) {
      response = yield call(
        InvoicePosService.listInvoiceBatchDetails,
        payload,
        bu_code,
        bu_parent
      );
    } else {
      response = yield call(
        InvoicePosService.listInvoicePos,
        payload,
        bu_code,
        bu_parent
      );
    }
    console.log(
      "🚀 ~ file: saga.js:298 ~ function*fetchListInvoicePos ~ response:",
      response
    );
    yield put(listInvoicePosSuccess(response));
  } catch (error) {
    console.log(
      "🚀 ~ file: saga.js:300 ~ function*fetchListInvoicePos ~ error:",
      error
    );
    yield put(listInvoicePosFail(errorMessage(error)));
  }
}

function* fetchDetailInvoicePos({
  id,
  typeInvoicePosAnother,
  data = null,
  isAdjustDecrease,
}) {
  try {
    let response = null;
    let responseLink = null;
    let responseAdjustLimit = null;
    if (typeInvoicePosAnother === TYPE_INVOICE_POS_ANOTHER.INVOICE_TICKETS) {
      response = yield call(InvoicePosService.detailInvoicePosTickets, id);
    } else if (
      typeInvoicePosAnother === TYPE_INVOICE_POS_ANOTHER.DELIVERY_BILL
    ) {
      response = yield call(InvoicePosService.detailDeliveryBill, id);
    } else if (
      typeInvoicePosAnother === TYPE_INVOICE_POS_ANOTHER.WAREHOUSE_AGENCY
    ) {
      response = yield call(InvoicePosService.detailWarehouseAgency, id);
    } else if (
      typeInvoicePosAnother === TYPE_INVOICE_POS_ANOTHER.INVOICE_TOTAL
    ) {
      const viewPendingBill = yield call(
        InvoicePosService.viewPendingBill,
        data
      );
      const detailPendingBill = yield call(
        InvoicePosService.detailPendingBill,
        data
      );
      response = {
        detailPendingBill: detailPendingBill,
        businessUnit: {
          ...viewPendingBill.businessUnit,
          invoice_template_code: viewPendingBill.item.invoice_template_code,
          serial: viewPendingBill.item.serial,
          soHd: "Chưa cấp số",
        },
        customer: {
          ...viewPendingBill.customer,
          payment_method_code: viewPendingBill.item.payment_method_code,
          currency_code: viewPendingBill.item.currency_code,
        },
        item: viewPendingBill.item,
      };
    } else {
      response = yield call(InvoicePosService.detailInvoicePos, id);
    }

    if (response) {
      // Get thông tin hoa don thay the /dieu chinh
      let idRootAdjust = id;
      let invoiceAdjustUpdateLimit = 0;
      if (
        typeInvoicePosAnother !== TYPE_INVOICE_POS_ANOTHER.INVOICE_TOTAL &&
        response?.link_type
      ) {
        let isGetChild = false;
        switch (response?.link_type) {
          // Parent có field này
          case LINK_TYPE.PARENT_REPLACE:
          case LINK_TYPE.PARENT_ADJUST:
            isGetChild = true;
            break;
          // Child có field này
          case LINK_TYPE.CHILD_REPLACE:
          case LINK_TYPE.CHILD_ADJUST:
            isGetChild = false;
            break;
          default:
            break;
        }
        responseLink = yield call(
          InvoicePosService.getDataLinkPos,
          response.id,
          isGetChild
        );
        if (responseLink) {
          if (isGetChild) {
            response.child = responseLink;
          } else {
            response.root = responseLink;
            idRootAdjust = responseLink.id;
            invoiceAdjustUpdateLimit = Number(response.ttoan_tgtttbso);
          }
        }
      }
      // Nếu là điều chỉnh giảm
      if (isAdjustDecrease) {
        responseAdjustLimit = yield call(
          InvoicePosService.getAdjustLimit,
          idRootAdjust
        );
        response.limit =
          Number(responseAdjustLimit.limit) - invoiceAdjustUpdateLimit;
      }
      yield put(getDetailInvoicePosSuccess(response));
    } else {
      yield put(getDetailInvoicePosFail("Lỗi"));
    }
  } catch (error) {
    yield put(getDetailInvoicePosFail(errorMessage(error)));
  }
}

function* onCreateInvoicePos({ payload, typeInvoicePosAnother }) {
  try {
    let response = null;
    let { buStoreHeader } = yield select(state => state.Dashboard);
    const data = payload.data;
    // lưu thông tin kh để sủ dụng lại
    if (data.isSaveInfoCustomer) {
      const saveInfoCustomer = {
        [FIELD_CUSTOMER.TEN]: data[INVOICE_POS_BUYER_FIELD.NMUA_TEN.field],
        [FIELD_CUSTOMER.MST]: data[INVOICE_POS_BUYER_FIELD.NMUA_MST.field],
        [FIELD_CUSTOMER.DCHI]: data[INVOICE_POS_BUYER_FIELD.NMUA_DCHI.field],
        [FIELD_CUSTOMER.MA]: data[INVOICE_POS_BUYER_FIELD.NMUA_MKHANG.field],
        [FIELD_CUSTOMER.SDTHOAI]:
          data[INVOICE_POS_BUYER_FIELD.NMUA_SDTHOAI.field],
        [FIELD_CUSTOMER.DCTDTU]:
          data[INVOICE_POS_BUYER_FIELD.NMUA_DCTDTU.field],
        [FIELD_CUSTOMER.STKNHANG]:
          data[INVOICE_POS_BUYER_FIELD.NMUA_STKNHANG.field],
        [FIELD_CUSTOMER.TNHANG]:
          data[INVOICE_POS_BUYER_FIELD.NMUA_TNHANG.field],
        [FIELD_CUSTOMER.TYPE_ID]: "1", // 1 doanh nghiệp, 2 khách lẻ
      };
      yield call(CustomerService.createCustomer, saveInfoCustomer);
    }
    payload.data = {
      ...payload.data,
      pending_van: 1,
    };
    if (typeInvoicePosAnother === TYPE_INVOICE_POS_ANOTHER.INVOICE_TICKETS) {
      response = yield call(
        InvoicePosService.createInvoicePosTickets,
        payload,
        buStoreHeader
      );
    } else if (
      typeInvoicePosAnother === TYPE_INVOICE_POS_ANOTHER.DELIVERY_BILL
    ) {
      response = yield call(
        InvoicePosService.createDeliveryBill,
        payload,
        buStoreHeader
      );
    } else if (
      typeInvoicePosAnother === TYPE_INVOICE_POS_ANOTHER.WAREHOUSE_AGENCY
    ) {
      response = yield call(
        InvoicePosService.createWarehouseAgency,
        payload,
        buStoreHeader
      );
    } else {
      response = yield call(
        InvoicePosService.createInvoicePos,
        payload,
        buStoreHeader
      );
    }
    // Wait XML generate
    yield sleep(1);
    yield put(
      backupDataNewPos({ ...response, typeAutoReload: TYPE_AUTO_RELOAD.IS_NEW })
    );
    yield put(createInvoicePosSuccess(response));
  } catch (error) {
    yield put(createInvoicePosFail(errorMessage(error)));
  }
}

function* onEditInvoicePos({ payload, id, typeInvoicePosAnother, auto_sign }) {
  try {
    // Check điều kiện khi edit hóa đơn
    let responseCheckStatus = yield call(
      InvoicePosService.checkInvoicePosStatus,
      id
    );
    if (responseCheckStatus.invoice.auth_status !== AUTH_STATUS_NEW) {
      yield put(
        editInvoicePosFail(
          "Hóa đơn đã được gửi phát hành, bạn không được quyền cập nhật"
        )
      );
      return;
    }

    let response = null;
    const data = payload.data;
    // lưu thông tin kh để sủ dụng lại
    if (data.isSaveInfoCustomer) {
      const saveInfoCustomer = {
        [FIELD_CUSTOMER.TEN]: data[INVOICE_POS_BUYER_FIELD.NMUA_TEN.field],
        [FIELD_CUSTOMER.MST]: data[INVOICE_POS_BUYER_FIELD.NMUA_MST.field],
        [FIELD_CUSTOMER.DCHI]: data[INVOICE_POS_BUYER_FIELD.NMUA_DCHI.field],
        [FIELD_CUSTOMER.MA]: data[INVOICE_POS_BUYER_FIELD.NMUA_MKHANG.field],
        [FIELD_CUSTOMER.SDTHOAI]:
          data[INVOICE_POS_BUYER_FIELD.NMUA_SDTHOAI.field],
        [FIELD_CUSTOMER.DCTDTU]:
          data[INVOICE_POS_BUYER_FIELD.NMUA_DCTDTU.field],
        [FIELD_CUSTOMER.STKNHANG]:
          data[INVOICE_POS_BUYER_FIELD.NMUA_STKNHANG.field],
        [FIELD_CUSTOMER.TNHANG]:
          data[INVOICE_POS_BUYER_FIELD.NMUA_TNHANG.field],
        [FIELD_CUSTOMER.TYPE_ID]: "1", // 1 doanh nghiệp, 2 khách lẻ
      };
      yield call(CustomerService.createCustomer, saveInfoCustomer);
    }
    if (auto_sign === 1) {
      payload.data["auto_sign"] = auto_sign;
      payload.data["integrate_release_mode"] = "DEFAULT";
    }
    if (typeInvoicePosAnother === TYPE_INVOICE_POS_ANOTHER.INVOICE_TICKETS) {
      response = yield call(
        InvoicePosService.editInvoicePosTickets,
        payload.data,
        id
      );
    } else if (
      typeInvoicePosAnother === TYPE_INVOICE_POS_ANOTHER.DELIVERY_BILL
    ) {
      response = yield call(
        InvoicePosService.editDeliveryBill,
        payload.data,
        id
      );
    } else if (
      typeInvoicePosAnother === TYPE_INVOICE_POS_ANOTHER.WAREHOUSE_AGENCY
    ) {
      response = yield call(
        InvoicePosService.editWarehouseAgency,
        payload.data,
        id
      );
    } else {
      response = yield call(InvoicePosService.editInvoicePos, payload.data, id);
    }
    if (auto_sign === 1) {
      yield put(
        backupDataNewPos({
          id,
          typeAutoReload: TYPE_AUTO_RELOAD.IS_RELEASE,
        })
      );
    }
    // Wait XML generate
    yield sleep(1);
    yield put(editInvoicePosSuccess(response));
  } catch (error) {
    yield put(editInvoicePosFail(errorMessage(error)));
  }
}

function* fetchDownloadXmlInvoicePos({
  resource_id,
  fileDownloadName,
  responseType = "blob",
  typeInvoicePosAnother,
  typeFile = ".xml",
}) {
  try {
    let response = null;
    if (typeInvoicePosAnother === TYPE_INVOICE_POS_ANOTHER.INVOICE_TICKETS) {
      response = yield call(
        InvoicePosService.downloadFileXMLInvoicePosTickets,
        resource_id,
        responseType
      );
    } else if (
      typeInvoicePosAnother === TYPE_INVOICE_POS_ANOTHER.DELIVERY_BILL
    ) {
      response = yield call(
        InvoicePosService.downloadFileXMLDeliveryBill,
        resource_id,
        responseType
      );
    } else if (
      typeInvoicePosAnother === TYPE_INVOICE_POS_ANOTHER.WAREHOUSE_AGENCY
    ) {
      response = yield call(
        InvoicePosService.downloadFileXMLWarehouseAgency,
        resource_id,
        responseType
      );
    } else if (
      typeInvoicePosAnother === TYPE_INVOICE_POS_ANOTHER.PHASE_INVOICE_POS
    ) {
      response = yield call(
        InvoicePosService.downloadFileXMLPhaseInvoicePos,
        resource_id,
        responseType
      );
    } else {
      response = yield call(
        InvoicePosService.downloadFileXMLInvoicePos,
        resource_id,
        responseType
      );
    }
    if (response) {
      if (responseType === "blob") {
        if (
          response.size > 0 &&
          response.size !== undefined &&
          response.size !== null
        ) {
          const file = URL.createObjectURL(response);
          yield put(
            downloadXmlInvoicePosSuccess(
              null,
              file,
              fileDownloadName + typeFile
            )
          );
        } else {
          yield put(downloadXmlInvoicePosFail("Download file thất bại"));
        }
      } else {
        // console.log("base64_encode", Buffer.from(response).toString("base64"));
        yield put(
          downloadXmlInvoicePosSuccess(
            Buffer.from(response).toString("base64"),
            null,
            fileDownloadName + typeFile
          )
        );
      }
    } else {
      yield put(downloadXmlInvoicePosFail("Download file thất bại"));
    }
  } catch (error) {
    yield put(downloadXmlInvoicePosFail(errorMessage(error)));
  }
}

function* loadConfigInvoicePosField({}) {
  try {
    let businessUnitInfo = null;
    let listCurrency = [];
    let listVat = [];
    let listPaymentMethod = [];

    const responseVat = yield call(InvoicePosService.listVats);
    const responsePay = yield call(InvoicePosService.listPaymentMethods);
    const responseCur = yield call(InvoicePosService.listCurrencies);
    // const responseBus = yield call(InvoicePosService.getBusinessUnits);
    if (responseVat) {
      listVat = responseVat.items.map(item => {
        return {
          value: item.tsuat,
          label: item.ltsuat,
          id: item.id,
        };
      });
    }
    // if (responseBus) {
    //   businessUnitInfo = responseBus.items[0];
    // }
    if (responsePay) {
      listPaymentMethod = responsePay.items.map(item => {
        return {
          value: item.htttoan,
          label: item.htttoan,
          id: item.id,
        };
      });
    }
    // Nếu có VND thì move lên đầu
    let defaultVND = {
      value: "VND",
      label: "VND",
    };
    if (responseCur) {
      let items = responseCur.items.map(item => {
        return {
          value: item.dvtte,
          label: item.dvtte,
        };
      });
      if (!items.filter(item => item.label === "VND") || items.length === 0) {
        items.push(defaultVND);
      }
      items = items.sort((x, y) => {
        return x.label == "VND" ? -1 : y.label == "VND" ? 1 : 0;
      });
      listCurrency = items;
    } else {
      // K có thì mặc dịnh VND
      listCurrency = [defaultVND];
    }
    yield put(
      loadConfigInvoicePosFieldSuccess(
        businessUnitInfo,
        listCurrency,
        listVat,
        listPaymentMethod
      )
    );
  } catch (error) {
    yield put(loadConfigInvoicePosFieldFail(errorMessage(error)));
  }
}

function* getEnterpriseByTaxCode({ taxCode }) {
  try {
    const response = yield call(
      InvoicePosService.getEnterpriseByTaxCode,
      taxCode
    );
    if (response) {
      yield put(getEnterpriseByTaxCodeSuccess({ taxCode, ...response }));
    } else {
      yield put(getEnterpriseByTaxCodeFail("getEnterpriseByTaxCodeFail error"));
    }
  } catch (error) {
    yield put(getEnterpriseByTaxCodeFail(errorMessage(error)));
  }
}

function* fetchReleaseInvoicePos({
  id,
  typeSend,
  typeInvoicePosAnother,
  transferData,
  isCreateAdjust,
  idAdjust,
}) {
  try {
    let responseCheckStatus = null;
    // Check điều kiện khi phát hành hóa đơn
    if (typeInvoicePosAnother !== TYPE_INVOICE_POS_ANOTHER.INVOICE_TOTAL) {
      responseCheckStatus = yield call(
        InvoicePosService.checkInvoicePosStatus,
        id
      );
      if (responseCheckStatus.invoice.auth_status !== AUTH_STATUS_NEW) {
        yield put(
          releaseInvoicePosFail(
            "Hóa đơn đã được gửi phát hành, bạn không được quyền phát hành"
          )
        );
        return;
      }
    }
    let response = null;
    if (typeInvoicePosAnother === TYPE_INVOICE_POS_ANOTHER.INVOICE_TICKETS) {
      response = yield call(
        InvoicePosService.releaseInvoicePosTicket,
        id,
        typeSend
      );
    } else if (
      typeInvoicePosAnother === TYPE_INVOICE_POS_ANOTHER.DELIVERY_BILL
    ) {
      response = yield call(
        InvoicePosService.releaseDeliveryBill,
        id,
        typeSend
      );
    } else if (
      typeInvoicePosAnother === TYPE_INVOICE_POS_ANOTHER.WAREHOUSE_AGENCY
    ) {
      response = yield call(
        InvoicePosService.releaseWarehouseAgency,
        id,
        typeSend
      );
    } else if (
      typeInvoicePosAnother === TYPE_INVOICE_POS_ANOTHER.INVOICE_TOTAL
    ) {
      const result = yield call(
        InvoicePosService.releaseInvoicePosTotal,
        transferData
      );
      response = {
        result: result,
      };
    } else {
      response = yield call(InvoicePosService.releaseInvoicePos, id, typeSend);
    }
    let adjustAll = null;
    if (response.result) {
      yield put(
        backupDataNewPos({
          ...responseCheckStatus?.invoice,
          typeAutoReload: TYPE_AUTO_RELOAD.IS_RELEASE,
        })
      );
      if (isCreateAdjust) {
        try {
          let responseAdjust = yield call(
            InvoicePosService.createInvoicePosEnterpriseAdjustAll,
            idAdjust
          );
          adjustAll = responseAdjust;
        } catch (error) {
          console.log(
            "🚀 ~ createInvoicePosEnterpriseAdjustAll ~ error",
            error
          );
        }
      }
      // Wait
      yield sleep(1);
      yield put(releaseInvoicePosSuccess(adjustAll));
    } else {
      let textObject = "hóa đơn";
      switch (typeInvoicePosAnother) {
        case TYPE_INVOICE_POS_ANOTHER.INVOICE_TICKETS:
          textObject = "tem phiếu";
          break;
        case TYPE_INVOICE_POS_ANOTHER.DELIVERY_BILL:
          textObject = "phiếu xuất kho vc nội bộ";
          break;
        case TYPE_INVOICE_POS_ANOTHER.WAREHOUSE_AGENCY:
          textObject = "phiếu xuất kho gửi bán đại lý";
          break;
        default:
          break;
      }
      let error = `Phát hành ${textObject} thất bại`;
      if (response.min_date) {
        error = `Cần phát hành ${textObject} ngày ${response.min_date} trước khi phát hành ${textObject} này`;
      }
      if (response.max_date) {
        const max_date = moment(response.max_date).format("DD-MM-YYYY");
        error = `Đã có ${textObject} phát hành ngày ${max_date}. Vui lòng  cập nhật ngày lập của ${textObject} hiện tại về ${max_date} hoặc lớn hơn (nhưng phải nhỏ hơn ngày hiện tại).`;
      }
      if (
        response?.message?.ttchung_nlap?.[0] ===
        "Nlap and time system not match"
      ) {
        error =
          "Ký hiệu hóa đơn không hợp lệ với Năm hiện tại, vui lòng cập nhật lại HĐ";
      }
      yield put(releaseInvoicePosFail(error));
    }
  } catch (error) {
    yield put(releaseInvoicePosFail(errorMessage(error)));
  }
}

function sleep(sec) {
  return new Promise(resolve => setTimeout(resolve, sec * 1000));
}

// typeSend
// REGISTER: 1,
// INVOICE: 2,
// HDSS: 3, // Thông báo HD sai sót
// HDTH: 4, // bảng tổng hợp
// WAREHOUSES: 6, //Phiếu xuất kho
function* fetchTransferUsb({ id, typeSend, content }) {
  try {
    const data = {
      id,
      type: typeSend,
      content,
    };
    const response = yield call(InvoicePosService.transfer, data);
    if (response.result) {
      yield sleep(1);
      yield put(transferUsbInvoicePosSuccess());
    } else {
      yield put(transferUsbInvoicePosFail(response?.error?.content));
    }
  } catch (error) {
    yield put(transferUsbInvoicePosFail(errorMessage(error)));
  }
}

function* fetchGenerateNumberInvoicePos({ id, typeInvoicePosAnother }) {
  try {
    // Check điều kiện khi generate số hóa đơn khi ký usb
    let responseCheckStatus = yield call(
      InvoicePosService.checkInvoicePosStatus,
      id
    );
    if (responseCheckStatus.invoice.auth_status !== AUTH_STATUS_NEW) {
      yield put(
        generateNumberInvoicePosFail(
          "Hóa đơn đã được gửi phát hành, bạn không được quyền ký số và phát hành"
        )
      );
      return;
    }

    let response = null;
    if (typeInvoicePosAnother === TYPE_INVOICE_POS_ANOTHER.DELIVERY_BILL) {
      response = yield call(
        InvoicePosService.generateNumberInvoicePosWarehouses,
        id
      );
    } else if (
      typeInvoicePosAnother === TYPE_INVOICE_POS_ANOTHER.WAREHOUSE_AGENCY
    ) {
      response = yield call(
        InvoicePosService.generateNumberWarehouseAgency,
        id
      );
    } else {
      response = yield call(InvoicePosService.generateNumberInvoicePos, id);
    }
    if (response.result) {
      yield put(generateNumberInvoicePosSuccess(response.items.resource_id));
    } else {
      yield put(
        generateNumberInvoicePosFail("Generate Number InvoicePos fail")
      );
    }
  } catch (error) {
    yield put(generateNumberInvoicePosFail(errorMessage(error)));
  }
}

function* fetchReplaceInvoicePos({
  id_root,
  attach_ids,
  data,
  typeInvoicePosAnother,
  infoTT32,
}) {
  try {
    const invoice = {
      ...data,
    };
    let response = null;
    // TT32:
    if (infoTT32) {
      let { buStoreHeader, buTenantHeaderInfo } = yield select(
        state => state.Dashboard
      );
      let bu_parent = undefined;
      let bu_code = undefined;
      if (buStoreHeader === ALL_STORE) {
        bu_parent = buTenantHeaderInfo.id;
      } else {
        bu_code = buStoreHeader;
      }
      const invoice = {
        ...data,
        tthdlquan_gchu: infoTT32?.tthdlquan_gchu,
        tthdlquan_shdclquan: infoTT32?.tthdlquan_shdclquan,
        tthdlquan_khmshdclquan: infoTT32?.tthdlquan_khmshdclquan,
        tthdlquan_nlhdclquan: infoTT32?.tthdlquan_nlhdclquan,
        tthdlquan_khhdclquan: infoTT32?.tthdlquan_khhdclquan,
        bu_code,
      };
      switch (infoTT32.modeTT32) {
        case MODE_INVOICE_POS_ACTION.REPLACE:
          response = yield call(
            InvoicePosService.replaceInvoicePosTT32,
            attach_ids,
            invoice
          );
          break;
        case MODE_INVOICE_POS_ACTION.ADJUST:
          response = yield call(
            InvoicePosService.adjustInvoicePosTT32,
            attach_ids,
            infoTT32.typeAdjust,
            invoice
          );
        default:
          break;
      }
    } else {
      if (typeInvoicePosAnother === TYPE_INVOICE_POS_ANOTHER.INVOICE_TICKETS) {
        response = yield call(
          InvoicePosService.replaceInvoicePosTickets,
          id_root,
          attach_ids,
          invoice
        );
      } else if (
        typeInvoicePosAnother === TYPE_INVOICE_POS_ANOTHER.DELIVERY_BILL
      ) {
        response = yield call(
          InvoicePosService.replaceDeliveryBill,
          id_root,
          attach_ids,
          invoice
        );
      } else if (
        typeInvoicePosAnother === TYPE_INVOICE_POS_ANOTHER.WAREHOUSE_AGENCY
      ) {
        response = yield call(
          InvoicePosService.replaceWarehouseAgency,
          id_root,
          attach_ids,
          invoice
        );
      } else {
        response = yield call(
          InvoicePosService.replaceInvoicePos,
          id_root,
          attach_ids,
          invoice
        );
      }
    }

    if (response.result) {
      yield put(
        backupDataNewPos({
          ...response.data,
          typeAutoReload: TYPE_AUTO_RELOAD.IS_REPLACE,
        })
      );
      yield put(replaceInvoicePosSuccess(response.data));
    } else {
      yield put(replaceInvoicePosFail(response.error));
    }
  } catch (error) {
    yield put(replaceInvoicePosFail(errorMessage(error)));
  }
}

function* fetchAdjustInvoicePos({
  id_root,
  attach_ids,
  adjust_mod,
  data,
  typeInvoicePosAnother,
}) {
  try {
    const invoice = {
      ...data,
    };
    let response = null;
    if (typeInvoicePosAnother === TYPE_INVOICE_POS_ANOTHER.INVOICE_TICKETS) {
      response = yield call(
        InvoicePosService.adjustInvoicePosTickets,
        id_root,
        attach_ids,
        adjust_mod,
        invoice
      );
    } else if (
      typeInvoicePosAnother === TYPE_INVOICE_POS_ANOTHER.DELIVERY_BILL
    ) {
      response = yield call(
        InvoicePosService.adjustDeliveryBill,
        id_root,
        attach_ids,
        adjust_mod,
        invoice
      );
    } else if (
      typeInvoicePosAnother === TYPE_INVOICE_POS_ANOTHER.WAREHOUSE_AGENCY
    ) {
      response = yield call(
        InvoicePosService.adjustWarehouseAgency,
        id_root,
        attach_ids,
        adjust_mod,
        invoice
      );
    } else {
      response = yield call(
        InvoicePosService.adjustInvoicePos,
        id_root,
        attach_ids,
        adjust_mod,
        invoice
      );
    }
    if (response.result) {
      yield put(
        backupDataNewPos({
          ...response.data,
          typeAutoReload: TYPE_AUTO_RELOAD.IS_ADJUST,
        })
      );
      yield put(adjustInvoicePosSuccess(response.data));
    } else {
      yield put(adjustInvoicePosFail(response.error));
    }
  } catch (error) {
    yield put(adjustInvoicePosFail(errorMessage(error)));
  }
}

function* fetchPreviewPdfInvoicePos({ id, isPolicy, isConvert, isNoneCopy }) {
  try {
    // Call api
    let response = null;
    if (isPolicy) {
      response = yield call(InvoicePosService.pdfReturnGoods, id);
    } else if (isConvert) {
      response = yield call(InvoicePosService.pdfConvert, id);
    } else if (isNoneCopy) {
      response = yield call(InvoicePosService.pdfNoneCopy, id);
    } else {
      response = yield call(InvoicePosService.reviewPdfInvoicePos, id);
    }
    if (response.result && response.file) {
      const blob = base64toBlob(response.file);
      const url = URL.createObjectURL(blob);
      yield put(previewPdfInvoicePosSuccess(url));
    } else {
      yield put(previewPdfInvoicePosFail("Không tồn tại file"));
    }
  } catch (error) {
    yield put(previewPdfInvoicePosFail(errorMessage(error)));
  }
}

function* fetchDeleteInvoicePos({ id, typeInvoicePosAnother }) {
  try {
    // Check điều kiện khi xóa hóa đơn
    let responseCheckStatus = yield call(
      InvoicePosService.checkInvoicePosStatus,
      id
    );
    if (responseCheckStatus.invoice.auth_status !== AUTH_STATUS_NEW) {
      yield put(
        deleteInvoicePosFail(
          "Hóa đơn đã được gửi phát hành, bạn không được quyền xóa"
        )
      );
      return;
    }
    // Call api
    let response = null;

    if (typeInvoicePosAnother === TYPE_INVOICE_POS_ANOTHER.INVOICE_TICKETS) {
      response = yield call(InvoicePosService.deleteInvoicePosTickets, id);
    } else if (
      typeInvoicePosAnother === TYPE_INVOICE_POS_ANOTHER.DELIVERY_BILL
    ) {
      response = yield call(InvoicePosService.deleteDeliveryBill, id);
    } else if (
      typeInvoicePosAnother === TYPE_INVOICE_POS_ANOTHER.WAREHOUSE_AGENCY
    ) {
      response = yield call(InvoicePosService.deleteWarehouseAgency, id);
    } else {
      response = yield call(InvoicePosService.deleteInvoicePos, id);
    }
    yield put(deleteInvoicePosSuccess());
  } catch (error) {
    yield put(deleteInvoicePosFail(errorMessage(error)));
  }
}

function* fetchCancelInvoicePos({
  listInvoice,
  typeCancel,
  typeInvoicePosAnother,
  attach_ids,
}) {
  try {
    // Call api
    let response = null;
    let { buStoreHeader } = yield select(state => state.Dashboard);
    if (typeInvoicePosAnother === TYPE_INVOICE_POS_ANOTHER.INVOICE_TICKETS) {
      response = yield call(
        InvoicePosService.cancelInvoicePosTickets,
        typeCancel,
        listInvoice,
        attach_ids,
        buStoreHeader
      );
    } else if (
      typeInvoicePosAnother === TYPE_INVOICE_POS_ANOTHER.DELIVERY_BILL
    ) {
      response = yield call(
        InvoicePosService.cancelDeliveryBill,
        typeCancel,
        listInvoice,
        attach_ids,
        buStoreHeader
      );
    } else if (
      typeInvoicePosAnother === TYPE_INVOICE_POS_ANOTHER.WAREHOUSE_AGENCY
    ) {
      response = yield call(
        InvoicePosService.cancelWarehouseAgency,
        typeCancel,
        listInvoice,
        attach_ids,
        buStoreHeader
      );
    } else {
      response = yield call(
        InvoicePosService.cancelInvoicePos,
        typeCancel,
        listInvoice,
        attach_ids,
        buStoreHeader
      );
    }
    if (response?.result) {
      yield put(
        backupDataNewPos({
          id: listInvoice.length === 1 ? listInvoice[0]?.id : null,
          typeAutoReload: TYPE_AUTO_RELOAD.IS_CANCEL,
        })
      );
      yield put(cancelInvoicePosSuccess());
    } else {
      yield put(cancelInvoicePosFail());
    }
  } catch (error) {
    yield put(cancelInvoicePosFail(errorMessage(error)));
  }
}

function* fetchCallBackTaxRefusedApprovalInvoicePos({ id }) {
  try {
    // Call api
    let response = yield call(
      InvoicePosService.callBackTaxRefusedApprovalInvoicePos,
      id
    );
    if (response?.result) {
      yield put(callBackTaxRefusedApprovalInvoicePosSuccess());
    } else {
      yield put(callBackTaxRefusedApprovalInvoicePosFail());
    }
  } catch (error) {
    yield put(callBackTaxRefusedApprovalInvoicePosFail(errorMessage(error)));
  }
}

function* onUploadFile({ payload }) {
  try {
    const response = yield call(InvoicePosService.uploadFile, payload);
    if (response.id) {
      yield put(uploadAttackFileInvoicePosSuccess(response.id));
    } else {
      yield put(uploadAttackFileInvoicePosFail("Lỗi uplaod file"));
    }
  } catch (error) {
    yield put(
      uploadAttackFileInvoicePosFail(errorMessage(error), payload.type)
    );
  }
}

function* fetchGetReportWord({ id, typeReport, fileName }) {
  try {
    // Call api
    const response = yield call(
      InvoicePosService.getReportWord,
      id,
      typeReport
    );
    if (response) {
      //   const blob = base64toBlob(response.file);
      const url = URL.createObjectURL(response);
      yield put(getInvoicePosReportWordSuccess(url, fileName));
    } else {
      yield put(getInvoicePosReportWordFail("Không tồn tại file"));
    }
  } catch (error) {
    yield put(getInvoicePosReportWordFail(errorMessage(error)));
  }
}

function* fetchActionWorkflowInvoicePos({ id, typeWorkflow, note }) {
  try {
    // Call api
    let action = null;
    switch (typeWorkflow) {
      case TYPE_ACTION_WORKFLOW.SUBMIT:
        action = "submit";
        break;
      case TYPE_ACTION_WORKFLOW.APPROVE:
        action = "approve";
        break;
      case TYPE_ACTION_WORKFLOW.REJECT:
        action = "reject";
        break;
      default:
        break;
    }
    const response = yield call(
      InvoicePosService.actionWorkflowInvoicePos,
      id,
      action,
      note
    );
    yield put(actionWorkflowInvoicePosSuccess(typeWorkflow));
  } catch (error) {
    yield put(actionWorkflowInvoicePosFail(errorMessage(error), typeWorkflow));
  }
}

function* fetchCreateInvoicePosEnterprise({ id, typeClone }) {
  try {
    // Call api
    const response = yield call(
      InvoicePosService.createInvoicePosEnterprise,
      id,
      typeClone
    );
    console.log(
      "🚀 ~ file: saga.js ~ line 1067 ~ function*fetchCreateInvoicePosEnterprise ~ response",
      response
    );
    yield put(createInvoicePosEnterpriseSuccess(response));
  } catch (error) {
    yield put(createInvoicePosEnterpriseFail(errorMessage(error)));
  }
}

function* fetchCreateInvoicePosEnterpriseAdjustAll({ id }) {
  try {
    // Call api
    const response = yield call(
      InvoicePosService.createInvoicePosEnterpriseAdjustAll,
      id
    );
    yield put(createInvoicePosEnterpriseAdjustAllSuccess(response));
  } catch (error) {
    yield put(createInvoicePosEnterpriseAdjustAllFail(errorMessage(error)));
  }
}

function* fetchUploadFileInvoicePos({ root_id, attach_ids }) {
  try {
    // Call api
    const response = yield call(
      InvoicePosService.uploadFileInvoicePos,
      root_id,
      attach_ids
    );
    if (response && response.result) {
      yield put(uploadFileInvoicePosSuccess());
    } else {
      yield put(uploadFileInvoicePosFail("Upload biên bản đính kèm thất bại"));
    }
  } catch (error) {
    yield put(uploadFileInvoicePosFail(errorMessage(error)));
  }
}

function* fetchRemoveFileInvoicePos({ id }) {
  try {
    // Call api
    const response = yield call(InvoicePosService.deleteResourceGlobal, id);
    yield put(removeFileInvoicePosSuccess(id));
  } catch (error) {
    yield put(removeFileInvoicePosFail(errorMessage(error)));
  }
}

function* fetchExportInvoicePos({
  dataExport,
  fileName,
  path,
  invoiceReportType,
}) {
  try {
    let { buStoreHeader, buTenantHeaderInfo, listBuOfTenant } = yield select(
      state => state.Dashboard
    );
    let bu_parent = undefined;
    let bu_code = undefined;
    if (buStoreHeader === ALL_STORE) {
      bu_parent = buTenantHeaderInfo.id;
    } else if (buStoreHeader === ALL_BU) {
      bu_parent = listBuOfTenant
        .filter(item => item.id)
        .map(item => item.id)
        .join(",");
    } else {
      bu_code = buStoreHeader;
    }
    // Call api
    const response = yield call(
      InvoicePosService.exportInvoicePos,
      dataExport,
      path,
      bu_code,
      bu_parent,
      invoiceReportType
    );
    if (response) {
      if (response?.report_id) {
        yield put(exportInvoicePosSuccess(null, fileName, response?.report_id));
      } else {
        const url = URL.createObjectURL(response);
        yield put(exportInvoicePosSuccess(url, fileName, null));
      }
    } else {
      yield put(exportInvoicePosFail("Xuất hóa đơn thất bại"));
    }
  } catch (error) {
    yield put(exportInvoicePosFail(error));
  }
}

function* fetchExportInvoicePosTicket({ dataExport, fileName }) {
  try {
    let { buStoreHeader, buTenantHeaderInfo, listBuOfTenant } = yield select(
      state => state.Dashboard
    );
    let bu_parent = undefined;
    let bu_code = undefined;
    if (buStoreHeader === ALL_STORE) {
      bu_parent = buTenantHeaderInfo.id;
    } else if (buStoreHeader === ALL_BU) {
      bu_parent = listBuOfTenant
        .filter(item => item.id)
        .map(item => item.id)
        .join(",");
    } else {
      bu_code = buStoreHeader;
    }
    // Call api
    const response = yield call(
      InvoicePosService.exportInvoicePosTicket,
      dataExport,
      bu_code,
      bu_parent
    );
    if (response) {
      const url = URL.createObjectURL(response);
      yield put(exportInvoicePosTicketSuccess(url, fileName));
    } else {
      yield put(exportInvoicePosTicketFail("Xuất hóa đơn thất bại"));
    }
  } catch (error) {
    yield put(exportInvoicePosTicketFail(errorMessage(error)));
  }
}

function* fetchExportInvoicePosWarehouse({ dataExport, fileName }) {
  try {
    let { buStoreHeader, buTenantHeaderInfo, listBuOfTenant } = yield select(
      state => state.Dashboard
    );
    let bu_parent = undefined;
    let bu_code = undefined;
    if (buStoreHeader === ALL_STORE) {
      bu_parent = buTenantHeaderInfo.id;
    } else if (buStoreHeader === ALL_BU) {
      bu_parent = listBuOfTenant
        .filter(item => item.id)
        .map(item => item.id)
        .join(",");
    } else {
      bu_code = buStoreHeader;
    }
    // Call api
    const response = yield call(
      InvoicePosService.exportInvoicePosWarehouse,
      dataExport,
      bu_code,
      bu_parent
    );
    if (response) {
      const url = URL.createObjectURL(response);
      yield put(exportInvoicePosWarehousesSuccess(url, fileName));
    } else {
      yield put(exportInvoicePosWarehousesFail("Xuất hóa đơn thất bại"));
    }
  } catch (error) {
    yield put(exportInvoicePosWarehousesFail(errorMessage(error)));
  }
}

function* fetchExportInvoicePosWarehouseAgency({ dataExport, fileName }) {
  try {
    let { buStoreHeader, buTenantHeaderInfo, listBuOfTenant } = yield select(
      state => state.Dashboard
    );
    let bu_parent = undefined;
    let bu_code = undefined;
    if (buStoreHeader === ALL_STORE) {
      bu_parent = buTenantHeaderInfo.id;
    } else if (buStoreHeader === ALL_BU) {
      bu_parent = listBuOfTenant
        .filter(item => item.id)
        .map(item => item.id)
        .join(",");
    } else {
      bu_code = buStoreHeader;
    }
    // Call api
    const response = yield call(
      InvoicePosService.exportInvoicePosWarehouseAgency,
      dataExport,
      bu_code,
      bu_parent
    );
    if (response) {
      const url = URL.createObjectURL(response);
      yield put(exportInvoicePosWarehousesAgencySuccess(url, fileName));
    } else {
      yield put(exportInvoicePosWarehousesAgencyFail("Xuất hóa đơn thất bại"));
    }
  } catch (error) {
    yield put(exportInvoicePosWarehousesAgencyFail(errorMessage(error)));
  }
}

function* fetchInvoicePosCampaignList({ params }) {
  try {
    // console.log("fetchGetListUpload");
    // console.log("params", params);
    // Param
    const perPage = params.sizePerPage;
    const page = params.page;
    const columnFilter = params.columnFilter;
    const keywords = params.keywords;
    const sort = params.sort;
    let { finalListBuCode, listBuOfTenant, buStoreHeader, buTenantHeaderInfo } =
      yield select(state => state.Dashboard);
    let bu_parent = undefined;
    let bu_code = undefined;
    if (buStoreHeader === ALL_STORE) {
      bu_parent = buTenantHeaderInfo.id;
    } else if (buStoreHeader === ALL_BU) {
      bu_parent = listBuOfTenant
        .filter(item => item.id)
        .map(item => item.id)
        .join(",");
    } else {
      bu_code = buStoreHeader;
    }
    // Call api
    const response = yield call(
      InvoicePosService.invoicePosCampaignList,
      page,
      perPage,
      columnFilter,
      keywords,
      sort,
      bu_parent,
      bu_code
    );
    const totalCount = response._meta.totalCount;
    // console.log("response", response);
    yield put(getInvoicePosCampaignListSuccess(response.items, totalCount));
  } catch (error) {
    yield put(getInvoicePosCampaignListFail(errorMessage(error)));
  }
}

function* fetchUploadCampaignsInvoicePos({
  typeReport,
  report_id,
  store_code,
}) {
  try {
    // Call api
    const response = yield call(
      InvoicePosService.uploadCampaignInvoicePos,
      typeReport,
      report_id,
      store_code
    );
    if (response && response.report_id) {
      yield put(uploadCampaignsInvoicePosSuccess(response));
    } else {
      yield put(uploadCampaignsInvoicePosFail("Upload lô hóa đơn thất bại"));
    }
  } catch (error) {
    yield put(uploadCampaignsInvoicePosFail(errorMessage(error)));
  }
}

function* fetchReleaseCampaignInvoicePos({ id }) {
  try {
    // Call api
    const response = yield call(
      InvoicePosService.releaseCampaignInvoicePos,
      id
    );
    if (response?.result) {
      yield put(releaseCampaignsInvoicePosSuccess());
    } else {
      yield put(
        releaseCampaignsInvoicePosFail("Phát hành lô hóa đơn thất bại")
      );
    }
  } catch (error) {
    yield put(releaseCampaignsInvoicePosFail(errorMessage(error)));
  }
}

function* fetchDetailCampaignInvoicePos({ id }) {
  try {
    // Call api
    const response = yield call(InvoicePosService.campaignInvoicePosDetail, id);
    if (response) {
      yield put(invoicePosCampaignDetailSuccess(response));
    } else {
      yield put(invoicePosCampaignDetailFail("Detail lô hóa đơn"));
    }
  } catch (error) {
    yield put(invoicePosCampaignDetailFail(errorMessage(error)));
  }
}

function* fetchDataLinkType({ id, isGetChild }) {
  try {
    // Call api
    const response = yield call(
      InvoicePosService.getDataLinkPos,
      id,
      isGetChild
    );
    if (response) {
      yield put(getDataLinkPosSuccess(response, isGetChild));
    } else {
      yield put(getDataLinkPosFail("Lấy thông tin thất bại"));
    }
  } catch (error) {
    yield put(getDataLinkPosFail(errorMessage(error)));
  }
}

function* fetchGetMaxDate({ khmhdon, khhdon, bu_code }) {
  try {
    // Call api
    // Get thông tin giới hạn ngày lập được chọn
    let buCode = bu_code;
    if (!buCode) {
      let { buStoreHeader } = yield select(state => state.Dashboard);
      buCode = buStoreHeader;
    }
    let minDate = null;
    let response = yield call(
      InvoicePosService.invoiceMaxDate,
      khmhdon,
      khhdon,
      buCode
    );
    if (response && response.result && response.date) {
      minDate = moment(response.date * 1000).format("DD-MM-YYYY");
    } else {
      const currentDate = new Date();
      minDate = moment(new Date(currentDate.getFullYear(), 0, 1)).format(
        "DD-MM-YYYY"
      );
    }
    if (minDate.indexOf("Invalid date") !== -1) {
      const currentDate = new Date();
      minDate = moment(new Date(currentDate.getFullYear(), 0, 1)).format(
        "DD-MM-YYYY"
      );
    }
    if (response) {
      yield put(getInvoicePosMaxDateSuccess(minDate));
    } else {
      yield put(getInvoicePosMaxDateFail("Lấy thông tin ngày thất bại"));
    }
  } catch (error) {
    yield put(getInvoicePosMaxDateFail(errorMessage(error)));
  }
}

function* fetchGetMinDate({ khmhdon, khhdon, bu_code }) {
  try {
    // Call api
    // Get thông tin giới hạn ngày lập được chọn
    let buCode = bu_code;
    if (!buCode) {
      let { buStoreHeader } = yield select(state => state.Dashboard);
      buCode = buStoreHeader;
    }
    let minDate = null;
    let maxDate = null;
    let response = yield call(
      InvoicePosService.invoiceMinDate,
      khmhdon,
      khhdon,
      buCode
    );
    let responseMaxDate = yield call(
      InvoicePosService.invoiceMaxDate,
      khmhdon,
      khhdon,
      buCode
    );
    if (response && response.result && response.date) {
      minDate = response.date * 1000;
    }
    if (responseMaxDate && responseMaxDate.result && responseMaxDate.date) {
      maxDate = responseMaxDate.date * 1000;
    }
    if (response || responseMaxDate) {
      const data = {
        minDate,
        maxDate,
      };
      yield put(getInvoicePosMinDateSuccess(data));
    } else {
      yield put(getInvoicePosMinDateFail("Lấy thông tin ngày thất bại"));
    }
  } catch (error) {
    yield put(getInvoicePosMinDateFail(errorMessage(error)));
  }
}

function* fetchDownloadZipInvoicePos({ ids, typeFile, fileName }) {
  try {
    let { buStoreHeader, buTenantHeaderInfo, listBuOfTenant } = yield select(
      state => state.Dashboard
    );
    let bu_parent = undefined;
    let bu_code = undefined;
    if (buStoreHeader === ALL_STORE) {
      bu_parent = buTenantHeaderInfo.id;
    } else if (buStoreHeader === ALL_BU) {
      bu_parent = listBuOfTenant
        .filter(item => item.id)
        .map(item => item.id)
        .join(",");
    } else {
      bu_code = buStoreHeader;
    }
    // Call api
    const response = yield call(
      InvoicePosService.downloadZip,
      ids,
      typeFile,
      bu_code
    );
    if (response.result) {
      //   const url = URL.createObjectURL(response);
      yield put(
        downloadZipInvoicePosSuccess(null, fileName, {
          report_id: response.report_id,
          fileName,
          typeFile,
        })
      );
    } else {
      yield put(downloadZipInvoicePosFail("Download thất bại"));
    }
  } catch (error) {
    yield put(downloadZipInvoicePosFail(errorMessage(error)));
  }
}

function* fetchGetCurrentTime() {
  try {
    // Call api
    const response = yield call(InvoicePosService.getCurrentTimePos);
    if (response) {
      const date = new Date(response * 1000).setHours(0, 0, 0, 0);
      const momentDate = moment(date);
      const data = {
        year: momentDate.year(),
        date: date,
        momentDate: momentDate,
      };
      console.log(
        "🚀 ~ file: saga.js:1709 ~ function*fetchGetCurrentTime ~ data:",
        data
      );
      yield put(getCurrentTimePosSuccess(data));
    } else {
      yield put(getCurrentTimePosFail());
    }
  } catch (error) {
    yield put(getCurrentTimePosFail(errorMessage(error)));
  }
}

// START PHASE
function* fetchListPhaseInvoicePos({ payload }) {
  try {
    let response = null;
    let {
      finalListBuCode,
      listBuOfTenant,
      buStoreHeader,
      buTenantHeaderInfo,
      finalBuInfo,
    } = yield select(state => state.Dashboard);
    let bu_parent = undefined;
    let bu_code = undefined;
    if (buStoreHeader === ALL_STORE) {
      bu_parent = buTenantHeaderInfo.id;
    } else if (buStoreHeader === ALL_BU) {
      bu_parent = listBuOfTenant
        .filter(item => item.id)
        .map(item => item.id)
        .join(",");
    } else {
      bu_code = buStoreHeader;
    }

    response = yield call(
      InvoicePosService.listPhaseInvoicePos,
      payload,
      finalBuInfo?.mst
    );
    yield put(listPhaseInvoicePosSuccess(response));
  } catch (error) {
    yield put(listPhaseInvoicePosFail(errorMessage(error)));
  }
}
function* fetchDetailPhaseInvoicePos({ id }) {
  try {
    let response = null;
    response = yield call(InvoicePosService.detailPhaseInvoicePos, id);

    if (response) {
      yield put(getDetailPhaseInvoicePosSuccess(response));
    } else {
      yield put(getDetailPhaseInvoicePosFail("Lỗi"));
    }
  } catch (error) {
    yield put(getDetailPhaseInvoicePosFail(errorMessage(error)));
  }
}
// END PHASE

function* issueInvoicePosPosSaga() {
  yield takeEvery(INVOICE_POS_LIST, fetchListInvoicePos);
  yield takeEvery(INVOICE_POS_DETAIL, fetchDetailInvoicePos);
  yield takeEvery(PHASE_INVOICE_POS_LIST, fetchListPhaseInvoicePos);
  yield takeEvery(PHASE_INVOICE_POS_DETAIL, fetchDetailPhaseInvoicePos);
  yield takeEvery(LOAD_CONFIG_INVOICE_POS_FIELD, loadConfigInvoicePosField);
  yield takeEvery(GET_ENTERPRISE_POS_BY_TAX_CODE, getEnterpriseByTaxCode);
  yield takeEvery(INVOICE_POS_CREATE, onCreateInvoicePos);
  yield takeEvery(INVOICE_POS_EDIT, onEditInvoicePos);
  yield takeEvery(DOWNLOAD_XML_INVOICE_POS, fetchDownloadXmlInvoicePos);
  yield takeEvery(RELEASE_INVOICE_POS, fetchReleaseInvoicePos);
  yield takeEvery(TRANSFER_USB_INVOICE_POS, fetchTransferUsb);
  yield takeEvery(GENERATE_NUMBER_INVOICE_POS, fetchGenerateNumberInvoicePos);
  yield takeEvery(REPLACE_INVOICE_POS, fetchReplaceInvoicePos);
  yield takeEvery(ADJUST_INVOICE_POS, fetchAdjustInvoicePos);
  yield takeEvery(PREVIEW_PDF_INVOICE_POS, fetchPreviewPdfInvoicePos);
  yield takeEvery(DELETE_INVOICE_POS, fetchDeleteInvoicePos);
  yield takeEvery(CANCEL_INVOICE_POS, fetchCancelInvoicePos);
  yield takeEvery(
    CALL_BACK_TAX_REFUSED_APPROVAL_INVOICE_POS,
    fetchCallBackTaxRefusedApprovalInvoicePos
  );
  yield takeEvery(CLONE_ENVOICE_POS, getCloneEnvoicePos);
  yield takeEvery(SEND_MAIL_INVOICE_POS, sendMailInvoicePos);
  yield takeEvery(ATTACK_FILE_INVOICE_POS_UPLOAD, onUploadFile);
  yield takeEvery(GET_INVOICE_POS_REPORT_WORD, fetchGetReportWord);
  yield takeEvery(ACTION_WORKFLOW_INVOICE_POS, fetchActionWorkflowInvoicePos);
  yield takeEvery(
    CREATE_INVOICE_POS_ENTERPRISE,
    fetchCreateInvoicePosEnterprise
  );
  yield takeEvery(
    CREATE_INVOICE_POS_ENTERPRISE_ADJUST_ALL,
    fetchCreateInvoicePosEnterpriseAdjustAll
  );
  yield takeEvery(UPLOAD_FILE_INVOICE_POS, fetchUploadFileInvoicePos);
  yield takeEvery(REMOVE_FILE_INVOICE_POS, fetchRemoveFileInvoicePos);
  yield takeEvery(EXPORT_INVOICE_POS, fetchExportInvoicePos);
  yield takeEvery(EXPORT_INVOICE_POS_TICKET, fetchExportInvoicePosTicket);
  yield takeEvery(
    EXPORT_INVOICE_POS_WAREHOUSES,
    fetchExportInvoicePosWarehouse
  );
  yield takeEvery(
    EXPORT_INVOICE_POS_WAREHOUSES_AGENCY,
    fetchExportInvoicePosWarehouseAgency
  );
  yield takeEvery(INVOICE_POS_CAMPAIGN_LIST, fetchInvoicePosCampaignList);
  yield takeEvery(UPLOAD_CAMPAIGNS_INVOICE_POS, fetchUploadCampaignsInvoicePos);
  yield takeEvery(
    RELEASE_CAMPAIGNS_INVOICE_POS,
    fetchReleaseCampaignInvoicePos
  );
  yield takeEvery(INVOICE_POS_CAMPAIGN_DETAIL, fetchDetailCampaignInvoicePos);
  yield takeEvery(GET_DATA_LINK_POS, fetchDataLinkType);
  yield takeEvery(GET_INVOICE_POS_MAX_DATE, fetchGetMaxDate);
  yield takeEvery(GET_INVOICE_POS_MIN_DATE, fetchGetMinDate);
  yield takeEvery(DOWNLOAD_ZIP_INVOICE_POS, fetchDownloadZipInvoicePos);
  yield takeEvery(GET_CURRENT_TIME_POS, fetchGetCurrentTime);
}

export default issueInvoicePosPosSaga;
